import React, { useEffect, useState } from "react";
import Header from "../../../../components/Header/Header";
import LeftSideBar from "../../../../components/LeftSideBar/LeftSideBar";
import { Grid, Box } from "@mui/material";
import AdministratorHeader from "../../../../components/Header/AdministratorHeader";
import AuditActivityTable from "../../../../components/AuditTrailComponent/AuditActivityTable";
import { useSelector } from "react-redux";
import CustomizedSnackbars from "../../../../components/Snackbars/CustomizedSnackbars";

export default function UserActivity() {
  const userActivityList = useSelector((state) => state?.admin.userActivity);
  const apiStatus = useSelector((state) => state?.admin?.apiStatus);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (apiStatus && apiStatus !== undefined) {
      if (apiStatus?.apiError === true && apiStatus?.next === false) {
        setMessage(apiStatus?.message);
        setErr(true);
      }
    }
  }, [apiStatus]);

  return (
    <>
      <Header />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner">
            <AdministratorHeader
              isArrow={true}
              isExport={userActivityList?.data}
              text="Audit Trail"
            />
            <Grid item md={12}>
              <AuditActivityTable />
            </Grid>
          </Grid>
        </Grid>
        {err && (
          <CustomizedSnackbars
            severity="error"
            state={err}
            text={message}
            handleClose={() => setErr(false)}
          />
        )}
      </Box>
    </>
  );
}
